import { AssetType } from '@pidz/enums';

export const assetTypeMap = new Map<string, number>([
  [AssetType.COC, 17],
  [AssetType.COMPLAINTS_DOCUMENT, 25],
  [AssetType.INSURANCE_DOCUMENT, 1],
  [AssetType.INSURANCE_DOCUMENT_PAYMENT_PROOF, 26],
  [AssetType.VOG, 23],
]);
